<template>
  <section class="car" :id="data.key">
    <div class="car__bg-wrapper">
      <img src="@/images/cars/bg.webp" alt="bg" class="car__bg">

      <div class="car__content">
        <car-info :carData="data" @getCall="getCall" />

        <div class="car__contaner">
          <p class="car__label" v-html="data.label" @click="getCall"></p>

          <car-colors :colorsData="data" />
          <car-gallery 
            :galleryData="data"
            @openGallery="(car, i) => $emit('openFullGallery', car, i)"
          />
          <car-buttons class="car__buttons" @getCall="getCall" />
        </div>
      </div>
    </div>

    <car-bottom :bottomData="data" @getCall="getCall" class="car__bottom" />
  </section>
</template>

<script>
import Mixin from "@/common/mixin";
import CarInfo from "./components/car-info.vue";
import CarColors from "./components/car-colors.vue";
import CarGallery from "./components/car-gallery.vue";
import CarBottom from "./components/car-bottom.vue";
import CarButtons from "./components/car-buttons.vue";


export default {
  name: "car",
  components: { CarInfo, CarColors, CarGallery, CarBottom, CarButtons },
  props: ["data"],
  mixins: [Mixin],
};
</script>

<style lang="scss" scoped>
@import "@/styles/constants.scss";

.car {
  max-width: 100%;
  color: #fff;

  &__bg-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 1.7em 0 1.85em 2.45em;
    border-radius: 2em;
  }

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    object-fit: cover;
  }

  &__content {
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  &__contaner {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__label {
    margin-left: auto;
    font-size: 1.7em;
    font-weight: 700;
    text-transform: uppercase;
    padding: 0.35em 1.6em 0.35em;
    border-radius: 0.6em 0 0 0.6em;
    background: $primary;
    cursor: pointer;
  }

  &__bottom {
    display: none;
  }
}

@media (max-width: 800px) {
  .car {
    &__bg-wrapper {
      padding: 2em 1em 1em;
    }
    
    &__content {
      flex-direction: column;
    }

    &__contaner {
      max-width: 100%; 
    }

    &__label {
      margin-right: auto;
      margin-left: -0.6em;
      border-radius: 0 0.6em 0.6em 0;
    }

    &__bottom {
      display: block;
    }

    &__buttons {
      display: none;
    }
  }
}

</style>
